export default __webpack_public_path__ + "static/media/featured5.43ec7042.png";